import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Input, Button, ButtonToolbar, Modal} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm, controlledField} from '../../core/redux/form'
import extract from '../../core/extract'
import LoaderButton from '../../core/components/LoaderButton'
import {FINISH_MISSION_HINTS, FinishMissionCmd} from '../models'
import {FINISH_MISSION_CMD_UPDATED, sendFinishMissionCmd, updateFinishMissionCmd, loadTicket} from '../actions'
import i18n from '../i18n'

class FinishMissionModal extends Component {
    static propTypes = {
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    componentWillMount() {
        const {dispatch} = this.props
        // there is no required field in this cmd
        // so we have to init the cmd to pass form validation
        dispatch(updateFinishMissionCmd({}))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.ticket !== this.props.ticket) {
            this.setState({hint: null})
        }
    }

    _sendCmd() {
        const {dispatch, onHide} = this.props
        
        return dispatch(sendFinishMissionCmd()).then(() => {
            return dispatch(loadTicket())
        }).then(() => {
            onHide()
        })
    }

    render() {
        const {dispatch, form, cmd, ticket, onHide, ...others} = this.props
        const {hint} = this.state

        const hintField = () => {
            const value = hint || ''

            const onChange = (event) => {
                const hint = event.target.value || null

                const comment = extract(i18n.finishMissionHintEnum, hint, null)

                dispatch(updateFinishMissionCmd({comment}))
                this.setState({hint})
            }

            return {value, onChange}
        }

        return (
            <Modal
                onHide={onHide}
                {...others}>
                <Modal.Header>
                    <Modal.Title>{i18n.finishMission}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Input
                        type='select'
                        {...hintField()}>
                        <option value=''>{i18n.comment} ...</option>
                        {FINISH_MISSION_HINTS.map((hint) => (
                            <option
                                key={hint}
                                value={hint}>
                                {extract(i18n.finishMissionHintEnum, hint)}
                            </option>
                        ))}
                    </Input>
                    <Input
                        type='textarea'
                        rows={5}
                        {...controlledField(form.comment())} />
                    <ButtonToolbar>
                        <LoaderButton
                            bsStyle='primary'
                            bsSize='large'
                            className={cx({disabled: !form.isValid()})}
                            onClick={() => form.validate() && this._sendCmd() || dispatch(errorStatus(i18n.formInvalid))}>
                            {i18n.validate}
                        </LoaderButton>
                        <Button
                            bsSize='large'
                            onClick={onHide}>
                            {i18n.cancel}
                        </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        )
    }
}

FinishMissionModal = connectForm({
    target: 'cmd',
    schema: FinishMissionCmd.schema,
    action: FINISH_MISSION_CMD_UPDATED
})(FinishMissionModal)

FinishMissionModal = connect((state) => ({
    ticket: state.ticket.ticket,
    cmd: state.ticket.finishMissionCmd
}))(FinishMissionModal)

export default FinishMissionModal


// WEBPACK FOOTER //
// ./lib/ticket/components/FinishMissionModal.js